/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import * as yup from "yup";
import moment from "moment-timezone";
import DataTable from "../DataTable";
import { map, isEmpty } from 'lodash';
import EditWorkOrder from './EditWorkOrder';
import GoogleMapReact from "google-map-react";
import axios from "../../../../../../Lib/axios";
import AddService from "./AddService/AddService";
import EditService from "../../Common/EditService";
import PauseService from "../../Common/PauseService";
import ReviewService from "./ReviewService/ReviewService";
import pin from '../../../../../../Assets/images/pin.png';
import Loader from "../../../../../Common/Component/Loader";
import {errorHandle} from "../../../../../Common/errorHandle";
import close from '../../../../../../Assets/images/close.png';
import ViewServiceHistory from "../../Common/ViewServiceHistory";
import share from '../../../../../../Assets/images/share-icon.svg';
import workOrderStatus from '../../../../../Common/workOrderStatus.json';
import chevronDown from '../../../../../../Assets/images/chevron-down.png';
import chevronRight from '../../../../../../Assets/images/chevron-right.png';
import StatusOutsideAlerter from "../../../../../Common/statusOutsideAlerter";
import ServiceOutsideAlerter from "../../../../../Common/serviceOutsideAlerter";
import WorkOrderOutsideAlerter from "../../../../../Common/workOrderOutsideAlerter";
import TechnicianOutsideAlerter from "../../../../../Common/technicianOutsideAlerter";
import addGreenCircle from '../../../../../../Assets/images/add-circle-outline-green.svg';

import {message, Table, DatePicker, Popconfirm, Modal } from 'antd'
import playIcon from '../../../../../../Assets/images/pauseplay-icon.svg';
import editIcon from '../../../../../../Assets/images/edit-pencil-green.svg';
import { CheckOutlined, InfoCircleOutlined, ToolFilled } from '@ant-design/icons';

const { RangePicker } = DatePicker;

let MarkerPin = (props) =>
  <div className="marker_wrapper d-flex align-items-center">
    <img style={{ 'width': '15px' }} src={pin} alt="" className="pin" />
    <div className="pulse"><span style={{'color': 'red', 'whiteSpace': 'nowrap','fontSize': '9px', 'display': 'block','lineHeight': '14px'}}>{props?.address || ''}</span></div>
  </div>

const MAP_OPTIONS = { disableDoubleClickZoom: true,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false };

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

// mapping for cleaning areas
const formattedAreas = {
  'front yard': 'Front Yard',
  'back yard': 'Back Yard',
  'right side': 'Right Side',
  'left side': 'Left Side',
  'dog run': 'Dog Run',
  'fenced area': 'Fenced Area'
};

class Services extends Component {
  state = {
    serviceOrder: {},
    loader: false,
    selectedService: {},
    selectedView: 0,
    selectedHistory: [],
    historyCount: 0,
    currentHistory: {},
    historyPagination: { 
      showSizeChanger: false,
      pageSize: 10,
      ordering: "" },
    unavailableDays: [
      { key: 'sun', value: 'Sunday', checked: false },
      { key: 'mon', value: 'Monday', checked: false },
      { key: 'tues', value: 'Tuesday', checked: false },
      { key: 'wed', value: 'Wednesday', checked: false },
      { key: 'thurs', value: 'Thursday', checked: false },
      { key: 'fri', value: 'Friday', checked: false },
      { key: 'sat', value: 'Saturday', checked: false }
    ],
    pauseServiceVisible: false,
    viewHistory: false,
    editService: false,
    addOns: [],
    isUpdateDays: false,
    enquiryList: {},
    isEditEnquiry: false,
    customer: {},
    isUpdateService: false,
    startDate: null,
    endDate: null,
    serviceOrderFilter: [],
    workOrderFilter: [],
    fieldTechnicianFilter: [],
    workOrderCount: 0,
    workOrderList: [],
    serviceWorkOrderList: [],
    workOrderListPagination: { 
      showSizeChanger: false,
      pageSize: 10,
      ordering: "" },
    scheduled_time__range: null,
    service_order__uuid: [],
    work_order_number: [],
    technician__uuid: [],
    status: [],
    ordering: '',
    scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    scheduled_time__lt: null,
    viewType: 'upcoming',
    optionSelected: null,
    toggleServiceOrderFilter: false,
    toggleWorkOrderFilter: false,
    toggleTechnicianFilter: false,
    toggleStatusFilter: false,
    isServiceDetail: false,
    woSearch: '',
    transection_type: 'Create',
    deActivate: false,
    isModalVisible: false,
    isDeleteWOModalVisible: false,
    resumeModalVisible:false,
    preferred_start_date: '',
    pauseList: [],
    is_upcoming: true,
    isDeletePause: false,
    pause_uuid: '',
    pause_type: '',
    reviewServiceOrder: false
  }

  getRedirectToService = () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    
    return params.redirect_to_service;
  }

  getRedirectToWorkOrder = () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    
    return params.redirect_to_work_order;
  }

  componentDidMount = () => {
    this.props.onClearFromOverview();
    const { 
      customerId,
      getServiceOrder,
      getServiceOrderEnquiry,
      getServiceOrderById,
      reviewServiceOrder,
      enquiryList
    } = this.props;

    if(this.getRedirectToService())
    {
      const query = this.props.history?.location?.state?.query;

      this.setState({
        loader: true,
        selectedView: 3,
      }, () => this.onViewService(query.service));
      getServiceOrderById(query.service.uuid);
      getServiceOrderEnquiry({user__uuid: query.id});
      this.props.getServiceOrderFilter({service_order__user__uuid: query.id});
      this.props.getWorkOrderFilter({service_order__user__uuid: query.id, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
      this.props.getWorkOrderList({service_order__user__uuid: query.id, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
    }
    else if (this.getRedirectToWorkOrder())
    {
      const query = this.props.history?.location?.state?.query;

      this.setState({
        loader: true,
        showAddons: true,
        transection_type: query.transection_type==="Update"?"Update":"View",
        currentRecord: {uuid:query.work_order_uuid}
      });
      getServiceOrder({ user__uuid: customerId })
      getServiceOrderEnquiry({user__uuid: customerId});
      this.props.getServiceOrderFilter({service_order__user__uuid: customerId});
      this.props.getWorkOrderFilter({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
      this.props.getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
    }
    else
    {
      if (customerId) {
        this.setState({ loader: true, selectedView: 0, reviewServiceOrder: reviewServiceOrder });
        getServiceOrder({ user__uuid: customerId }) // get service orders
        getServiceOrderEnquiry({user__uuid: customerId}); // get service order enquiry
        this.props.getServiceOrderFilter({service_order__user__uuid: customerId});
        this.props.getWorkOrderFilter({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
        this.props.getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
      }
    }
    
    this.rerender = () => {
      try {
        const { customerId, getServiceOrder, getServiceOrderEnquiry } = this.props;
        this.setState({ loader: true, selectedView: 0 });
        getServiceOrder({ user__uuid: customerId }) // get service orders
        getServiceOrderEnquiry({user__uuid: customerId, limit: 1}); // get service order enquiry
        this.props.getServiceOrderFilter({service_order__user__uuid: customerId});
        this.props.getWorkOrderFilter({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
        this.props.getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
      } catch (e) {
        console.error(e);
      }
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    const {
      selectedService,
      unavailableDays,
      selectedHistory,
      isUpdateDays,
      isUpdateService,
      isServiceDetail,
      reviewServiceOrder,
      workOrderFilter
    } = this.state;
    const {customerId} = this.props;
    this.setState({ loader: false });

    if(nextProps?.Service?.errors?.service_address?.length > 0){
      message.error(nextProps?.Service?.errors?.service_address?.[0]);
    }
    if(nextProps?.Service?.errors?.service_address?.geo_location?.length > 0){
      message.error(nextProps?.Service?.errors?.service_address?.geo_location?.[0]);
    }

    if(nextProps?.reviewServiceOrder) {
      this.setState({ selectedView: 3, reviewServiceOrder: nextProps?.reviewServiceOrder });
    }

    // service order detail
    if (nextProps?.isServiceDetail === true && isServiceDetail !== nextProps?.isServiceDetail) {
      this.setState({ isServiceDetail: nextProps?.isServiceDetail }, () => {
        this.onViewService(nextProps?.objService)
      });
    }

    // errors
    if (nextProps?.service?.errors && Object.keys(nextProps?.service?.errors).length > 0 &&
      JSON.stringify(nextProps?.service?.errors) !== JSON.stringify(this.props?.service?.errors)) {
      this.setState({loader: false});
      errorHandle(nextProps?.service?.errors)
    }

    // get customer detail
    if (Object.keys(nextProps?.customerList?.customer).length > 0
      && JSON.stringify(nextProps?.customerList?.customer) !== JSON.stringify(this.state?.customer)) {

      this.props.getFranchiseById(nextProps?.customerList?.customer?.field_office?.uuid)
      this.setState({ customer: nextProps?.customerList?.customer });
    }
    
    // get service order
    if (Object.keys(nextProps?.serviceOrder?.data).length > 0 && nextProps?.serviceOrder?.data?.results?.length > 0) {
      this.setState({ serviceOrder: nextProps?.serviceOrder?.data }, () => {
        // console.warn('serviceOrder', this.state.serviceOrder)
      });
    }

    // get service order enquiry
    if (Object.keys(nextProps?.serviceOrderEnquiry?.enquiryList).length > 0
      && JSON.stringify(nextProps?.serviceOrderEnquiry?.enquiryList) !== JSON.stringify(this.state.enquiryList)) {
      this.setState({
        loader: false,
        enquiryList: nextProps?.serviceOrderEnquiry?.enquiryList,
        field_office_uuid: nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.field_office_uuid}, () => {
        
        if (reviewServiceOrder) {
          this.setState({
            isServiceDetail:reviewServiceOrder,
            selectedService: nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]
          }, () => {
            this.onViewService(nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]);
          })
        }
      });
    }

    // Get service history
    if (Object.keys(nextProps?.service?.data).length > 0
      && JSON.stringify(nextProps?.service?.data?.results) !== JSON.stringify(selectedHistory)) {
      let data = [];

      for (let index = 0; index < nextProps?.service?.data?.results.length; index++) {
        const element = nextProps?.service?.data?.results[index];
        element.scheduled_time = element.scheduled_time.replace('Z', '');
        data.push(element)
      }

      this.setState({ selectedHistory: data, historyCount: nextProps?.service?.data?.count });
    }

    // Edit service
    if (Object.keys(nextProps?.service?.editService).length > 0
      && JSON.stringify(nextProps?.service?.editService) !== JSON.stringify(this.state.selectedService)) {
      if (isUpdateDays || isUpdateService) {
        setTimeout(() => message.success('Updated Successfully.', 10), 500);
      }

      map(unavailableDays, obj => {
        obj.checked = !!nextProps?.service?.editService?.service_unavailable_days?.includes(obj.key);
      });

      this.props.viewService({
        service_order__uuid: nextProps?.service?.editService?.uuid,
        limit: 10,
        offset: 0,
        is_history: true
      });

      if (isUpdateDays || isUpdateService) {
        this.onFilterChange(),
        this.onChangeView(1),
        this.props.getWorkOrderFilter({
          service_order__user__uuid: customerId,
          service_order__uuid: selectedService?.uuid, 
          scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")
        }),
        this.props.getPauseService({ service_order__uuid: selectedService?.uuid }),
        this.clearStatus();
      }
      
      this.setState({ selectedService: { ...selectedService, ...nextProps?.service?.editService }, unavailableDays, isUpdateDays: false, isUpdateService: false });
    }

    // Get add ons
    if (Object.keys(nextProps?.service?.fieldOffice).length > 0) {
      this.setState({ addOns: nextProps?.service?.fieldOffice?.add_on});
    }

    //Get service order filters
    if (nextProps?.serviceOrderFilter && nextProps?.serviceOrderFilter?.data && nextProps?.serviceOrderFilter?.data?.data && Object.keys(nextProps?.serviceOrderFilter?.data?.data).length > 0) {
      this.setState({ serviceOrderFilter: nextProps?.serviceOrderFilter?.data?.data}, () => {
        // console.warn('serviceOrderFilter', this.state.serviceOrderFilter)
      });
    }
    
    //Get work order filters
    if (nextProps?.workOrderFilter && nextProps?.workOrderFilter?.data && nextProps?.workOrderFilter?.data?.data && Object.keys(nextProps?.workOrderFilter?.data?.data).length > 0 && 
    JSON.stringify(nextProps?.workOrderFilter?.data?.data) !== JSON.stringify(workOrderFilter)) {
      this.setState({ workOrderFilter: nextProps?.workOrderFilter?.data?.data}, () => {});
    }

    //get field technician filters
    if (nextProps?.fieldTechnicianFilter && nextProps?.fieldTechnicianFilter?.technicianList && nextProps?.fieldTechnicianFilter?.technicianList?.results && Object.keys(nextProps?.fieldTechnicianFilter?.technicianList?.results).length > 0) {
      this.setState({ fieldTechnicianFilter: nextProps?.fieldTechnicianFilter?.technicianList?.results}, () => {
        // console.warn('fieldTechnicianFilter', this.state.fieldTechnicianFilter)
      });
    }

    //get work orders
    if (nextProps?.workOrderList && nextProps?.workOrderList?.data && nextProps?.workOrderList?.data?.results && Object.keys(nextProps?.workOrderList?.data?.results).length > 0) {
      this.setState({ workOrderList: nextProps?.workOrderList?.data?.results}, () => {});
    } else {
      this.setState({ workOrderList: []}, () => {
        // console.warn('workOrderList', this.state.workOrderList)
      });
    }
    
    // get service order
    if (nextProps?.serviceOrder && nextProps?.serviceOrder?.viewOrder && Object.keys(nextProps?.serviceOrder?.viewOrder).length > 0
      && JSON.stringify(nextProps?.serviceOrder?.viewOrder) !== JSON.stringify(this.props?.serviceOrder?.viewOrder)) {
      this.setState({ selectedService: nextProps?.serviceOrder?.viewOrder });
    }
 
    // get pause service list
    if (Object.keys(nextProps?.service?.pauseList).length > 0
      && JSON.stringify(nextProps?.service?.pauseList) !== JSON.stringify(this.state.pauseList)) {
      this.setState({ pauseList: nextProps?.service?.pauseList });
    }
  }

  // on change view
  onChangeView = (value) => {
    this.setState({ selectedView: value })
  };

  //Table Server side pagination
  handleTableChange = (pagination) => {
    const { historyPagination, selectedService } = this.state;
    Object.assign(historyPagination, { 'current': pagination.current });
    this.setState({
      historyPagination,
      loader: true,
    })

    this.props.viewService({ 
      offset: (pagination.current * 10) - 10,limit: 10,service_order__uuid: selectedService?.uuid,ordering: historyPagination?.ordering,is_history: true });
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // on change day
  onChangeDay = (e, row) => {
    const { unavailableDays } = this.state;
    Object.assign(unavailableDays[row], { [e.target.name]: !e.target.checked });
    this.setState({ unavailableDays });
  };

  // toggle pause service
  togglePauseService = (value) => {
    const { selectedService } = this.state;
    const { getPauseService, customerId, getWorkOrderList, getServiceOrderById } = this.props;
    this.setState({ pauseServiceVisible: value })
    if (!value) {
      getServiceOrderById(selectedService?.uuid);
      getPauseService({ service_order__uuid: selectedService?.uuid });
      getWorkOrderList({service_order__user__uuid:`${customerId}`, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
    }
  };

  // toggle edit service
  toggleEditService = (value) => {
    this.setState({ editService: value })
  };

  // toggle view history
  toggleViewHistory = (value) => {
    this.setState({ viewHistory: value })
  };

  //Service history order
  onServiceHistoryOrder = (e) => {
    let { historyPagination, selectedService } = this.state;

    Object.assign(historyPagination, { 'ordering': e, current: 1 })
    this.setState({ historyPagination });
    let data = { service_order__uuid: selectedService?.uuid, ordering: e, limit: 10, offset: 0, is_history: true }

    if (e === '') {
      delete data.ordering;
    }
    this.props.viewService(data);
  }

  // on update unavailable day
  onUpdateDays = () => {
    const { selectedService, unavailableDays } = this.state;
    let service_unavailable_days = [];
    this.setState({loader: true, isUpdateDays: true})
    map(unavailableDays, (obj => {
      if (obj.checked) service_unavailable_days.push(obj.key)
    }));
    this.props.editService(selectedService?.uuid, {
      service_unavailable_days
    });
    this.props.viewService({ service_order__uuid: selectedService?.uuid, limit: 10, offset: 0, is_history: true });
  }

  // on view service click
  onViewService = (item) => {
    const { unavailableDays } = this.state;
    const { customerId } = this.props;

    this.setState({
      selectedService: item, 
      toggleServiceOrderFilter: false,
      toggleWorkOrderFilter: false,
      toggleTechnicianFilter: false,
      toggleStatusFilter: false,
      scheduled_time__range: null,
      service_order__uuid: [],
      work_order_number: [],
      technician__uuid: [],
      status: []
    },()=>{
      
    });
    map(unavailableDays, obj => {
      if (item?.service_unavailable_days?.includes(obj.key)) {
        obj.checked = true
      }
    });

    this.setState({ unavailableDays }, () => 
      this.onFilterChange(),
    this.onChangeView(1),
    this.props.getWorkOrderFilter({
      service_order__user__uuid: customerId,
      service_order__uuid: item?.uuid, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")}),
    this.props.getPauseService({ service_order__uuid: item?.uuid }),
    this.clearStatus()
    );
  }

  /**
   * AUTHOR: RITESH SOLANKI
   * <DP-3085>Deactivate a Service for a Residential Customer</DP-3085>
   */
  deactivateServiceOrderPopup = () => {
    const { deActivate } = this.state;
    this.setState({
      deActivate: !deActivate
    })
  }

  /**
   * AUTHOR: RITESH SOLANKI
   * <DP-3085>Deactivate a Service for a Residential Customer</DP-3085>
   */
  deactivateServiceOrder = () => {
    // message.destroy();
    const { selectedService } = this.state;
    const { customerId, getServiceOrder, getWorkOrderList } = this.props;
    this.setState({ deActivate: false });
    // this.props.deactivateServiceOrder(selectedService?.uuid, {is_active: false})
    axios.patch(`/partial-service-order/${selectedService?.uuid}/`, {is_active: false}).then((response) => {
      message.success(`Service order has been deactivated`, 10);
      this.props.toggleSidebar(true); 
      this.onChangeView(0);
      getServiceOrder({ user__uuid: customerId }) // get service orders
      getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
    }).catch(error => {
      message.error(`Error occurred while deactivating service order.`, 10);
    });
  }

  /**
   * AUTHOR: RITESH SOLANKI
   * <DP-3086>Reactivate an Inactive Service for a Residential Customer</DP-3086>
   */
  reactivateServiceOrder = () => {
    // message.destroy();
    const { selectedService, preferred_start_date } = this.state;
    const { customerId, getServiceOrder, getWorkOrderList } = this.props;
    /**
     * AUTHOR: Ritesh Solanki
     * <DP-3510>Reactivate Service Order : One-time service shows Preferred Next Service Date</DP-3510>
     */
    if (selectedService?.frequency === 'once') {
      axios.patch(`/partial-service-order/${selectedService?.uuid}/`, {is_active: true}).then((response) => {
        this.setIsModalVisible(false);
        message.success(`Service order has been deactivated`, 10);
        this.setState({ deActivate: false });
        this.props.toggleSidebar(true); 
        this.onChangeView(0);
        getServiceOrder({ user__uuid: customerId }) // get service orders
      }).catch(error => {
        message.error(`Error occurred while reactivating service order.`, 10);
      });
    } else {
      const schema = yup.object().shape({
        preferred_start_date: yup.string().required('Please select a service date.')
      });
      const data = { preferred_start_date };
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState(s => ({ errors: {} }));
        this.setState({ resumeModalVisible: false });
        axios.patch(`/partial-service-order/${selectedService?.uuid}/`, {is_active: true, preferred_start_date: moment(preferred_start_date, 'DD-MM-YYYY').format("YYYY-MM-DD")}).then((response) => {
          this.setIsModalVisible(false);
          message.success(`Service order has been deactivated`, 10);
          this.setState({ deActivate: false });
          this.props.toggleSidebar(true); 
          this.onChangeView(0);
          getServiceOrder({ user__uuid: customerId }) // get service orders
          getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
        }).catch(error => {
          message.error(`Error occurred while reactivating service order.`, 10);
        });
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message });
        this.setState(s => ({errors: err_data }));
      })
    }
  }

  /**
   * AUTHOR: RITESH SOLANKI
   * <DP-3091>Manually Resume a Paused Service for a Residential Customer</DP-3091>
   */
  resumeServiceOrder = () => {
    const { selectedService } = this.state;
    const { customerId, getServiceOrder, getWorkOrderList } = this.props;
    this.setState({ resumeModalVisible: false });
    axios.patch(`/service-pause/${selectedService?.pause_obj?.uuid}/`, {is_end_pause: true}).then((response) => {
      message.success(`Service order has been reactivated`, 10);
      this.props.toggleSidebar(true); 
      this.onChangeView(0);
      getServiceOrder({ user__uuid: customerId }) // get service orders
      getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
    }).catch(error => {
      message.error(`Error occurred while reactivating service order.`, 10);
    });
  }

  /**
   * AUTHOR: RITESH SOLANKI
   * <DP-3190>Delete a Work Order for a Residential Customer</DP-3190>
   */
  deleteWorkOrder = () => {
    const { currentRecord } = this.state;
    axios.delete(`/service-ftech/${currentRecord?.uuid}/`).then((response) => {
      message.success(`Work order ${currentRecord?.work_order_number || ""} deleted.`, 10);
      this.onFilterChange();
    }).catch(error => {
      message.error(`Error occurred while deleting Work order.`,10);
    });
  }

  setIsModalVisible = (isModalVisible) => {
    this.setState({
      isModalVisible: isModalVisible
    })
  }

  // render service overview
  renderServiceOverview = (item, isEnquiry) => {
    // const {addOns} = this.state;
    const dog_suffix = item?.calculated_price?.pet_count === 1 ? 'dog' : 'dogs';
    let arr = [];
    if (item?.frequency) arr.push(`${FREQUENCY_MAPPING[item?.frequency]} service`)
    if (item?.area_to_clean?.length > 0) arr.push(`${formattedAreas[item?.area_to_clean?.[0]]}`)
    if (item?.calculated_price?.pet_count > 0) arr.push(`${item?.calculated_price?.pet_count} ${dog_suffix}`)

    const cleaning_areas = item?.calculated_price?.cleaning_areas;
    let arr_cleaning_area = [];
    
    if (!isEmpty(cleaning_areas) && !isEmpty(cleaning_areas.items)) {
      map(cleaning_areas.items, (item) => {
        if (item.price !== 0) {
          arr_cleaning_area.push(item.area);
        }        
      });
    }

    const {
      selectedService,
      serviceOrder,
      deActivate,
      isModalVisible,
      resumeModalVisible,
      preferred_start_date,
      errors,
      reviewServiceOrder
    } = this.state;
    const isPending = this?.props?.customer?.status === 'pending';

    return (
      <React.Fragment>
        <div className="">
          <span style={{color: "#1F1F25", fontSize: 12}}>{item?.service_order_number ? `${item?.service_order_number}` : ''} <span style={{textTransform: "capitalize", opacity: "0.5"}}>{item?.frequency_type ? `${this.setRecurring(item?.frequency_type)}` : ''}</span></span>
          <div className="flex" style={{alignItems: 'center', marginBottom: 12}}>
            <h5 style={{paddingRight: 10, marginTop: 6, marginBottom: 2}}>{!isEmpty(item?.service_address) ? `${item?.service_address?.address}, ${item?.service_address?.city}, ${item?.service_address?.state} ${item?.service_address?.zip_code}` : '-'}</h5>
            {!isPending && !reviewServiceOrder && <>{item?.is_active && !item?.is_paused && <span className="status success-status drk">ACTIVE</span>}
              {item?.is_paused && !reviewServiceOrder && <span className="status warning-status drk">PAUSED</span>}
              {!item?.is_active && !reviewServiceOrder && !item?.is_paused && <span className="status gray-status drk">INACTIVE</span>}</>}
            {isPending && !reviewServiceOrder && <span className="status info-status drk">PENDING</span>}
            {reviewServiceOrder && <span className="status info-status drk">INQUIRED</span>}
          </div>
          <span className="altude">{!isEmpty(item?.service_address?.geo_location?.latitude) ? `${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}` : ``}</span>
          {
            item?.service_address?.geo_location ?
              <div className="map mb-10">
                <GoogleMapReact
                  bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY }}
                  options={MAP_OPTIONS}
                  defaultCenter={{ lat: item?.service_address?.geo_location?.latitude, lng: item?.service_address?.geo_location?.longitude }}
                  defaultZoom={15}
                >
                  <MarkerPin
                    address={item?.service_address?.address}
                    lat={item?.service_address?.geo_location?.latitude?.toString()}
                    lng={item?.service_address?.geo_location?.longitude?.toString()} />
                </GoogleMapReact>
              </div> :
              ''
          }
          <div className="pb-0 flex">
            {reviewServiceOrder && 
              <button className="btn btn-warning px-10 flex-1" onClick={() => {
                this.setState({isEditEnquiry: false}, () => {
                  this.props.toggleSidebar(true)
                  this.onChangeView(3)
                })
              }}>Review Service Order</button>
            }
            {
              !isPending && <>
                <button
                  className="btn btn-warning px-10 flex-1"
                  onClick={() => this.toggleEditService(true)}
                >
                  Edit this Service Order
                </button>
                {
                  !selectedService?.is_active &&
                  <button className={'btn btn-brand btn-bdr flex ai-center justify-content-center px-10 disable'}>
                    <img className="mr-5" src={playIcon} alt=""/>
                  Pause</button>
                }
                {
                  !selectedService?.is_paused && selectedService?.is_active &&
                  <button className={!selectedService?.is_active ? 'btn btn-brand btn-bdr flex ai-center justify-content-center px-10 disable' : 'btn btn-brand btn-bdr flex ai-center justify-content-center px-10'}
                    onClick={() => {
                      this.props.getPauseService({ service_order__uuid: selectedService?.uuid }) // get pause service list
                      this.togglePauseService(true);
                    }}>
                    <img className="mr-5" src={playIcon} alt=""/>
                  Pause</button>
                }
              </>}
            {(selectedService?.is_paused && !isPending) &&
              <React.Fragment>
                <button className="btn btn-brand btn-bdr flex ai-center justify-content-center px-10" onClick={() => {
                  this.setState({resumeModalVisible:true});
                }}>
                  <img className="mr-5" src={playIcon} alt=""/>
              Resume</button>
                <Modal
                  visible={resumeModalVisible}
                  okText={"Resume Service Order"}
                  cancelText={"Cancel"}
                  onOk={() => {
                    this.resumeServiceOrder()
                    this.setState({resumeModalVisible:false})
                  }}
                  onCancel={() => {
                    this.setState({resumeModalVisible:false})
                  }}
                  className="delete_user_modal"
                  width={400}
                >   
                  <h3>Resume Service Order</h3>
                  <p>This service order is currently on a pause:</p>
                  <div className="alert-dateblock">
                    <span>{moment(selectedService?.pause_obj?.pause_from).format("MMMM DD, YYYY")} to {selectedService?.pause_obj?.pause_to?moment(selectedService?.pause_obj?.pause_to).format("MMMM DD, YYYY"):'Indefinite'}</span>
                    <span>{selectedService?.pause_obj?.reason?.reason}</span>
                    <span>Our dog(s) will not be home.</span>
                  </div>
                </Modal>
              </React.Fragment>
            }
            {!isPending && <button className="btn dots-button" onClick={() => { this.deactivateServiceOrderPopup() }}>
              <span></span>
              <span></span>
              <span></span>
            </button>}
          </div>
          {deActivate && <div className="pb-0 flex pt-10 justify-content-end">
            {selectedService?.is_active &&
              <button className="btn btn-brand btn-bdr flex ai-center justify-content-center px-10" onClick={() => this.setIsModalVisible(true)}>Deactivate Service Order</button>
            }
            {!selectedService?.is_active &&
              <button className="btn btn-brand btn-bdr flex ai-center justify-content-center px-10" onClick={() => this.setIsModalVisible(true)}>Reactivate Service Order</button>
            }
            
            <Modal
              visible={isModalVisible}
              okText={`${selectedService?.is_active ? 'Deactivate' : 'Reactivate'}`}
              cancelText={"Cancel"}
              onOk={() => {
                if (selectedService?.is_active) {
                  this.deactivateServiceOrder();
                  setTimeout(() => {
                    this.setIsModalVisible(false)
                  }, 1500)
                } else {
                  this.reactivateServiceOrder();
                }                
              }}
              onCancel={() => {
                this.setState({
                  preferred_start_date: '',
                  errors: {}
                })
                this.setIsModalVisible(false);
              }}
              className="delete_user_modal"
              width={400}
            >   
              <h3>{`${selectedService?.is_active ? 'Deactivate' : 'Reactivate'} Service Order`}</h3>
              <p>{`Are you sure you would like to ${selectedService?.is_active ? 'deactivate' : 'reactivate'} this service order?`}</p>
              {selectedService?.is_active && <React.Fragment>
                <p>All Forecast work orders will be cancelled and deleted.</p>
                <p>Any Scheduled work orders will need to be determined manually</p>
              </React.Fragment>}
              {!selectedService?.is_active && selectedService?.frequency !== 'once' && <React.Fragment>
                <p>As this is a recurring service order, please specify the date to resume service at this button.</p>
                <div className="field-group">
                  <label>Next Service<sup>*</sup></label>
                  <DatePicker
                    style={{ 'width': '100%' }}
                    format="YYYY-MM-DD"
                    name='preferred_start_date'
                    disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                    suffixIcon={<i className="las la-calendar"></i>}
                    allowClear={true}
                    value={preferred_start_date}
                    onChange={(e) => {
                      if (e) {
                        this.setState(s => ({ preferred_start_date: e }))
                      } else {
                        this.setState(s => ({ preferred_start_date: '' }))
                      }
                    }}
                  />
                  {errors?.['preferred_start_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['preferred_start_date']}</label> : ''}
                </div>
              </React.Fragment>}
            </Modal>
          </div>}
          <hr />
          {
            !reviewServiceOrder && <div className="active_service_list lh-21 color-252730">
              {map(serviceOrder?.results, this.renderServiceDetails)}
            </div>
          }

          {
            reviewServiceOrder && <div className="active_service_list lh-21 color-252730">
              {this.renderServiceDetails(selectedService, 0)}
            </div>
          }
        </div>
      </React.Fragment>
    )
  }

  // render service
  renderService = (isEnquiry) => (item, index) => {
    // for pre-pay message
    const expDate = moment(item?.initial_cleaning).add(6, 'month')
    const diff = moment(expDate).diff(moment(), 'days');
    const displayDiff = moment(expDate).fromNow();
    const displayText = diff < 0 ? `expired for ${displayDiff}` : `will expires in the next ${displayDiff}`;
    
    return (
      <React.Fragment key={`service${index}`}>
        <div className="card">
          <div className="card-body p-0">
            {this.renderServiceOverview(item, isEnquiry)}
            <div className="plr-15">
              {isEnquiry ? <button
                className="btn btn-warning btn-full mt-20 mb-10"
                onClick={() => {this.setState({isEditEnquiry: true}, () => {
                  this.props.toggleSidebar(false)
                  this.onChangeView(2)
                }) }}
              >View</button> : <button
                className="btn btn-warning btn-full mt-20 mb-10"
                onClick={() => this.onViewService(item)}
              >View Single Service</button>}
              {(item?.calculated_price?.is_prepaid && diff <= 30) &&
              <blockquote className="horiz">
                <b>This service is on a pre-pay plan. This {displayText}.</b>
                <p className="mb-0">This customer needs to update their pre-pay plan, or move to monthly payments.</p>
              </blockquote>}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  // render add new box
  renderAdditionalServiceBox = () => {
    return (
      <div className="card add-card">
        <h5>Create an additional service</h5>
        <p>This can be new service, an additional service or a one-time extra service at any address for this customer.</p>
        <button className="btn btn-warning lg-btn" onClick={() => this.setState({isEditEnquiry: false}, () => {
          this.props.toggleSidebar(false)
          this.onChangeView(2)
        })}>Add New Service</button>
      </div>
    )
  }

  /**
   * AUTHOR: Ritesh Solanki
   * Changed: 24-11-2021 12:52 PM (Wednesday)
   * <DP-3375>View Services | Extra dividing line appears below last service in a given status</DP-3375>
   * @param totalLength - DP-3375 Changes
   */
  renderActiveService = (totalLength) => (item, index) => {
    if (item?.is_active && !item?.is_paused) {
      return (
        <React.Fragment key={`service${index}`}>
          <div className="flex justify-content-start position-relative">
            {/*
              * AUTHOR: Ritesh Solanki
              * Changed: 24-11-2021 1:17 PM (Wednesday)
              * <DP-3381>View Services | Click box to select a service is not correct</DP-3381>
              * Added pointer class and click event on order number and address
            */}
            <strong className="snum pointer" onClick={() => this.setState({isServiceDetail: true}, () => { this.onViewService(item) })}>{item?.service_order_number}</strong>
            <span className="color-1F1F25 opacity-5 fs-12">{this.setRecurring(item.frequency)}</span>
          </div>
          <div className="position-relative">
            <span className="service-arrow" onClick={() => 
              this.setState({isServiceDetail: true}, () => {
                this.onViewService(item)
                /**
                   * AUTHOR: Ritesh Solanki
                   * <DP-3094>View Pauses for a Residential Customer</DP-3094>
                   * getPauseService to get pause upcoming & hostory of service order
                   */
                const { getPauseService } = this.props;
                getPauseService({ service_order__uuid: item?.uuid })
              })} >
              <img src={chevronRight} alt=""/>
            </span>
            <h5 className="sadd mb-4 pointer" onClick={() => this.setState({isServiceDetail: true}, () => { this.onViewService(item) })}>{!isEmpty(item?.service_address?.formatted_address) ? `${item?.service_address?.formatted_address}` : '-'}</h5>
            {!isEmpty(item?.service_address?.geo_location)? <span className="latitude pl-20 opacity-5 fs-11">{`${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}`}</span> : <></>}
            {item?.last_increase_effective_date?
              <div>
                <strong class="altude pl-20 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase Date: {item?.last_increase_effective_date?this.UTCToLocal(item?.last_increase_effective_date).format('MMM DD, YYYY'):"-"}</strong>
                <strong class="altude pl-20 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase: {item?.last_increase_amount?item?.last_increase_amount:"-"}  {item?.last_increase_status? item?.last_increase_status === "Completed"?"(Applied)":"(Yet to be applied)" : "-"}</strong>                        
              </div>
            :
              <></>
            }
          </div>
          {(totalLength - 1) !== index && <hr />}
        </React.Fragment>
      )
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3492></DP-3492>
   */
  renderInquiryService = (totalLength) => (item, index) => {
    if (item?.is_active && !item?.is_paused) {
      return (
        <React.Fragment key={`service${index}`}>
          <div className="flex justify-content-start position-relative">
            <strong className="snum pointer" onClick={() => this.setState({isServiceDetail: true, reviewServiceOrder: true}, () => { this.onViewService(item) })}>{item?.service_order_number}</strong>
            <span className="color-1F1F25 opacity-5 fs-12">{this.setRecurring(item.frequency)}</span>
          </div>
          <div className="position-relative">
            <span className="service-arrow" onClick={() => 
              this.setState({isServiceDetail: true, reviewServiceOrder: true}, () => {
                this.onViewService(item)
                /**
                   * AUTHOR: Ritesh Solanki
                   * <DP-3094>View Pauses for a Residential Customer</DP-3094>
                   * getPauseService to get pause upcoming & hostory of service order
                   */
                // const { getPauseService } = this.props;
                // getPauseService({ service_order__uuid: item?.uuid })
              })} >
              <img src={chevronRight} alt=""/>
            </span>
            <h5 className="sadd mb-4 pointer" onClick={() => this.setState({isServiceDetail: true, reviewServiceOrder: true}, () => { this.onViewService(item) })}>{!isEmpty(item?.service_address?.formatted_address) ? `${item?.service_address?.formatted_address}` : '-'}</h5>
            <span className="latitude pl-20 opacity-5 fs-11">{!isEmpty(item?.service_address?.geo_location) ? `${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}` : ``}</span>
          </div>
          {(totalLength - 1) !== index && <hr />}
        </React.Fragment>
      )
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3040>Activate a Pending Residential Customer, Finalize</DP-3040>
   */
  cancelReviewService = () => {
    const { selectedService } = this.state;
    const { customerId } = this.props;
    this.setState({
      isServiceDetail: false,
      reviewServiceOrder: false,
      showAddons: false
    }, () => {
      const { customerId, getServiceOrder, getServiceOrderEnquiry } = this.props;
      this.setState({ loader: true });
      Promise.allSettled([
        getServiceOrder({ user__uuid: customerId }),
        getServiceOrderEnquiry({user__uuid: customerId, limit: 1})
      ]).then(result => {
        const isFulfilled = result.filter(x => x.status === "fulfilled");
        if (isFulfilled?.length > 0) {
          this.onViewService(selectedService);
        }
      });
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * Changed: 24-11-2021 12:52 PM (Wednesday)
   * <DP-3375>View Services | Extra dividing line appears below last service in a given status</DP-3375>
   * @param totalLength - DP-3375 Changes
   */
  renderPausedService = (totalLength) => (item, index) => {
    const { pause_obj } = item;
    if (item?.is_paused) {
      return (
        <React.Fragment key={`service${index}`}>
          <div className="flex position-relative">
            {/*
              * AUTHOR: Ritesh Solanki
              * Changed: 24-11-2021 1:17 PM (Wednesday)
              * <DP-3381>View Services | Click box to select a service is not correct</DP-3381>
              * Added pointer class and click event on order number and address
            */}
            <strong className="snum pointer" onClick={() => this.setState({isServiceDetail: true}, () => { this.onViewService(item) })}>{item?.service_order_number}</strong>
            <span className="color-22232A d-flex justify-content-between">{this.setRecurring(item.frequency)}</span>
            <span className="service-arrow" onClick={() => 
              this.setState({isServiceDetail: true}, () => {
                this.onViewService(item)
              })}>
              <img src={chevronRight} alt=""/>
            </span>
          </div>
          <h5 className="sadd pointer" onClick={() => this.setState({isServiceDetail: true}, () => { this.onViewService(item) })}>{!isEmpty(item?.service_address?.formatted_address) ? `${item?.service_address?.formatted_address}` : '-'}</h5>
          {!!pause_obj && <span className="pause-duration">Paused from {moment(pause_obj?.pause_from).format("MMMM DD, YYYY")} to {pause_obj?.pause_to ? moment(pause_obj?.pause_to).format("MMMM DD, YYYY") : 'Indefinite'} </span>}
          <span className="latitude">{!isEmpty(item?.service_address?.geo_location) ? `${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}` : ``}</span>
          {(totalLength - 1) !== index && <hr />}
        </React.Fragment>
      )
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * Changed: 24-11-2021 12:52 PM (Wednesday)
   * <DP-3375>View Services | Extra dividing line appears below last service in a given status</DP-3375>
   * @param totalLength - DP-3375 Changes
   */
  renderInactiveService = (totalLength) => (item, index) => {
    if (!item?.is_active) {
      return (
        <React.Fragment key={`service${index}`}>
          <div className="flex position-relative">
            {/*
              * AUTHOR: Ritesh Solanki
              * Changed: 24-11-2021 1:17 PM (Wednesday)
              * <DP-3381>View Services | Click box to select a service is not correct</DP-3381>
              * Added pointer class and click event on order number and address
            */}
            <strong className="snum pointer" onClick={() => this.setState({isServiceDetail: true}, () => { this.onViewService(item) })}>{item?.service_order_number}</strong>
            <span className="color-22232A d-flex justify-content-between">{this.setRecurring(item.frequency)}</span>
            <span className="service-arrow" onClick={() => 
              this.setState({isServiceDetail: true}, () => {
                this.onViewService(item)
              })}>
              <img src={chevronRight} alt=""/>
            </span>
          </div>
          <h5 className="sadd pointer" onClick={() => this.setState({isServiceDetail: true}, () => { this.onViewService(item) })}>{!isEmpty(item?.service_address?.formatted_address) ? `${item?.service_address?.formatted_address}` : '-'}</h5>
          {!isEmpty(item?.service_address?.geo_location) ? <span className="latitude">{`${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}`}</span> : <></>}
          <p class="altude pl-20 opacity-5 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase Date: {item?.last_increase_effective_date?this.UTCToLocal(item?.last_increase_effective_date).format('MMM DD, YYYY'):"-"}</p>
          <p class="altude pl-20 opacity-5 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase: {item?.last_increase_amount?item?.last_increase_amount:"-"}  {item?.last_increase_status? item?.last_increase_status === "Completed"?"(Applied)":"(Yet to be applied)" : "-"}</p>                        
          {(totalLength - 1) !== index && <hr />}

        </React.Fragment>
      )
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * Changed: 07-10-2021 07:15 PM (Thursday)
   * <DOOD-3205>Residential | Services | Active Service | Reccurence type is not present</DOOD-3205>
   */
  setRecurring = (frequency) => {
    switch (frequency) {
    case 'twice_weekly':
      return 'Twice Weekly'
    case 'weekly':
      return 'Weekly'
    case 'bi_monthly':
      return 'Every Other Week'
    case 'monthly':
      return 'Monthly'
    case 'once':
      return 'One-Time'
    default:
      return ''
    }
  }

  //Date range changed
  onDateRangeChange = (e) => {
    if(e){
      this.setState({
        scheduled_time__range: `${moment(e[0]).format('YYYY-MM-DD hh:mm:ss')},${moment(e[1]).format('YYYY-MM-DD 23:59:59')}`
      }, () => {
        this.onFilterChange();
      })
    } else{
      this.setState({
        scheduled_time__range: null
      }, () => {
        this.onFilterChange();
      })
    }
  }

  //api call after filter and sorting
  onFilterChange = () => {
    const { customerId } = this.props;
    const { scheduled_time__range, service_order__uuid, work_order_number, technician__uuid, status, ordering, scheduled_time__gte, scheduled_time__lt, isServiceDetail, selectedService, viewType } = this.state;
    const queryParams = {
      service_order__user__uuid:`${customerId}`,
      scheduled_time__range: `${scheduled_time__range}`,
      service_order__uuid__in: service_order__uuid && service_order__uuid.length > 0 ? `${service_order__uuid.join()}` : null,
      work_order_number__in: work_order_number && work_order_number.length > 0 ? `${work_order_number}` : null,
      technician__uuid__in: technician__uuid && technician__uuid.length > 0 ? `${technician__uuid.join()}` : null,
      status__in: status && status.length > 0 ? `${status.join()}` : null,
      ordering: `${ordering}`,
      scheduled_time__gte: `${scheduled_time__gte}`,
      scheduled_time__lt: `${scheduled_time__lt}`
    }
    if (isServiceDetail) {
      delete queryParams.service_order__uuid__in;
      queryParams['service_order__uuid'] = selectedService?.uuid;
    } else {
      delete queryParams.service_order__uuid;
    }
    const params = this.filterParams(queryParams);
    this.props.getWorkOrderList(params);
    if (viewType === "upcoming") {
      this.props.getWorkOrderFilter({
        service_order__user__uuid: customerId,
        ...(selectedService ? {service_order__uuid: selectedService?.uuid} : null), 
        scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")
      });
    } else if (viewType === "history") {
      this.props.getWorkOrderFilter({
        service_order__user__uuid: customerId, 
        ...(selectedService ? {service_order__uuid: selectedService?.uuid} : null), 
        scheduled_time__lt: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")
      });
    }
  }

  //Remove null object properties
  filterParams = (params) => {
    for (var propName in params) {
      if (params[propName] === "" || params[propName] === null || params[propName] === "null" || params[propName] === undefined || params[propName] === "undefined") {
        delete params[propName];
      }
    }
    return params
  }

  // on sorting selected
  onWorkOrderHandleChange = (pagination, filters, sorter) => {
    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }

    if (ordering) {
      this.setState({ ordering: ordering }, () => {
        this.onFilterChange();
      });
    } else {
      this.setState({ ordering: '' }, () => {
        this.onFilterChange();
      });
    }
  }

  upcomingWorkOrders = () => {
    const { customerId } = this.props;
    this.setState({
      viewType: 'upcoming',
      scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      scheduled_time__lt: null 
    }, () => {
      this.onFilterChange();
      this.props.getWorkOrderFilter({
        service_order__user__uuid: customerId,
        scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")
      });
    });
  }

  historyWorkOrders = () => {
    this.setState({
      viewType: 'history',
      scheduled_time__lt: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      scheduled_time__gte: null,
      ordering: '-scheduled_time'
    }, () => {
      this.onFilterChange();
    });
  }

  //#region "Service Order Filter"
  renderServiceOrderFilters =  () => {
    const { toggleServiceOrderFilter, serviceOrderFilter, service_order__uuid } = this.state;
    return (
      <ServiceOutsideAlerter
        closeServiceOrderFilter={this.closeServiceOrderFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtServiceOrder" placeholder={service_order__uuid && service_order__uuid.length === 0 ? 'All' : `${service_order__uuid.length} items selected`} onChange={(e) => { this.onSearchServiceOrder(e) }} onFocus={() => {this.toggleServiceOrder() }} />
            {service_order__uuid && service_order__uuid.length === 0 && 
              <img src={chevronDown} alt="" onClick={() => { this.toggleServiceOrder() }} />
            }
            {service_order__uuid && service_order__uuid.length > 0 && 
              <img src={close} alt="" onClick={() => { this.clearServiceOrder() }} />
            }
          </div>
          {toggleServiceOrderFilter && <div className="field-dropdown">
            <div className="field-dropdown-body">
              <div className="fitem-check">
                <input id="allServiceOrder" type="checkbox" className="fitem-ck-input" checked={ this.state?.allServiceOrderSelected } onChange={(e) => { this.onServiceOrderChanged(e, null, true)}} />
                <label htmlFor="allServiceOrder" className="fitem-ck-txt">All Service Orders</label>
              </div>
              {map(serviceOrderFilter, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item.uuid} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onServiceOrderChanged(e, index) }} checked={this.state?.service_order__uuid?.includes(item?.uuid)} /> {/* checked={item.is_change} */}
                    <label htmlFor={item.uuid} className="fitem-ck-txt">{item.service_order_number}</label>
                    <span className="fcheck-span">{item?.service_address?.formatted_address}</span>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearServiceOrder() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({toggleServiceOrderFilter: false}) }}>Update</button>
            </div>
          </div>}
        </div>
      </ServiceOutsideAlerter>
    )
  }

  toggleServiceOrder = () => {
    const { toggleServiceOrderFilter } = this.state;
    if (toggleServiceOrderFilter) {
      this.setState({ toggleServiceOrderFilter: false })
    } else {
      this.setState({ toggleServiceOrderFilter: true, toggleWorkOrderFilter: false, toggleTechnicianFilter: false, toggleStatusFilter: false })
    }
  }

  onSearchServiceOrder = (e) => {
    const { serviceOrderFilter } = this.state;
    if (e.target.value) {
      const data = serviceOrderFilter.filter( (obj) => {
        return obj.service_order_number.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
      });
      this.setState({serviceOrderFilter: data});
    } else {
      this.props.getServiceOrderFilter({service_order__user__uuid: this.props.customerId});
    }
  }

  onServiceOrderChanged = (e, index, isAll = false) => {
    const { serviceOrderFilter, service_order__uuid, allServiceOrderSelected } = this.state;
    var arrServiceUuid = [...service_order__uuid];

    if (isAll) {
      if (e.target.checked) {
        arrServiceUuid = serviceOrderFilter.map(item => item.uuid);
        document.getElementById("allServiceOrder").checked = true;
      } else {
        arrServiceUuid = [];
        document.getElementById("allServiceOrder").checked = false;
      }
    } else {
      if (e.target.checked) {
        // case where we want to toggle select all
        if (index === null) {
          arrServiceUuid = [];
          serviceOrderFilter.forEach(element => {
            element['is_change'] = !allServiceOrderSelected
            if(!allServiceOrderSelected) {
              arrServiceUuid.push(element?.uuid)
            }
          });
        } else {
          if (arrServiceUuid.indexOf(e.target.id) === -1) {
            document.getElementById("allServiceOrder").checked = false;
            arrServiceUuid.push(e.target.id)
            serviceOrderFilter[index]['is_change'] = true;
          }
        }
      } else {
        if (index === null) {
          arrServiceUuid = [];
          serviceOrderFilter.forEach(element => {
            element['is_change'] = false
          });
        } else {
          const ind = arrServiceUuid.indexOf(e.target.id);
          if (ind > -1) {
            arrServiceUuid.splice(ind, 1);
            serviceOrderFilter[index]['is_change'] = false;
            document.getElementById("allServiceOrder").checked = false;
          }
        }
      }
    }
    
    this.setState({ 
      service_order__uuid: arrServiceUuid, 
      // if All Service Order is selected then we toggle or we unset the allServiceOrderSelected flag.
      allServiceOrderSelected: (index === null) ? !allServiceOrderSelected : false 
    },() => {
      // console.warn('service_order__uuid', this.state.service_order__uuid);
    });    
  }

  clearServiceOrder = () => {
    const { serviceOrderFilter } = this.state;
    if (document.getElementById("allServiceOrder")) {
      document.getElementById("allServiceOrder").checked = false
    }
    serviceOrderFilter.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ service_order__uuid: [], toggleServiceOrderFilter: false, allServiceOrderSelected: false }, () => {
      this.onFilterChange()
    });
  }

  closeServiceOrderFilter = () => {
    this.setState({ toggleServiceOrderFilter: false })
  }

  //#endregion

  //#region "Work Order Filter"
  renderWorkOrderFilters =  () => {
    const { toggleWorkOrderFilter, workOrderFilter, work_order_number, woSearch = ''} = this.state;
    return (
      <WorkOrderOutsideAlerter
        closeWorkOrderFilter={this.closeWorkOrderFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtWorkOrder" 
              onChange={(e) => {
                this.setState({woSearch: e.target.value })
              }} 
              placeholder={work_order_number && work_order_number.length === 0 ? 'All' : `${work_order_number.length} items selected`} 
              onFocus={() => {this.toggleWorkOrder() }} 
            />
            {work_order_number && work_order_number.length === 0 && 
              <img src={chevronDown} alt="" onClick={() => { this.toggleWorkOrder() }} />
            }
            {work_order_number && work_order_number.length > 0 && 
              <img src={close} alt="" onClick={() => { this.clearWorkOrder() }} />
            }
          </div>
          {toggleWorkOrderFilter && <div className="field-dropdown">
            <div className="field-dropdown-body">
              <div className="fitem-check">
                <input id="allWorkOrder" type="checkbox" className="fitem-ck-input" checked={this.state?.allWorkOrderSelected} onChange={(e) => { this.onWorkOrderChanged(e, null, true)}} />
                <label htmlFor="allWorkOrder" className="fitem-ck-txt">All Workorders</label>
              </div>
              {map(workOrderFilter.filter(wo => ((wo?.address+wo?.work_order_number).includes(woSearch))), (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item?.uuid} type="checkbox" value={item?.work_order_number} className="fitem-ck-input chkWorkOrder" onChange={(e) => { this.onWorkOrderChanged(e, index)}} checked={this?.state?.work_order_number?.includes(item?.work_order_number)} /> {/* checked={item.is_change} */}
                    <label htmlFor={item?.uuid} className="fitem-ck-txt">{item?.work_order_number}</label>
                    <span className="fcheck-span">{item?.address}</span>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearWorkOrder() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({toggleWorkOrderFilter: false}) }}>Update</button>
            </div>
          </div>}
        </div>
      </WorkOrderOutsideAlerter>
    )
  }

  toggleWorkOrder = () => {
    const { toggleWorkOrderFilter } = this.state;
    if (toggleWorkOrderFilter) {
      this.setState({ toggleWorkOrderFilter: false })
    } else {
      this.setState({ toggleWorkOrderFilter: true, toggleServiceOrderFilter: false, toggleTechnicianFilter: false, toggleStatusFilter: false })
    }
  }

  onWorkOrderChanged = (e, index, isAll = false) => {
    const { workOrderFilter, work_order_number, allWorkOrderSelected } = this.state;
    let arrWorkOrderNumber = [...work_order_number];
    
    if(isAll) {
      if (e.target.checked) {
        arrWorkOrderNumber = workOrderFilter.map(item => item.work_order_number);
        document.getElementById("allWorkOrder").checked = true;
      } else {
        arrWorkOrderNumber = [];
        document.getElementById("allWorkOrder").checked = false;
      }
    } else {
      if (e.target.checked) {
        if (index === null) {
          arrWorkOrderNumber = [];
          workOrderFilter.forEach(element => {
            element['is_change'] = !allWorkOrderSelected
            if(!allWorkOrderSelected) {
              arrWorkOrderNumber.push(element?.work_order_number)
            }
          });
        } else {
          if (arrWorkOrderNumber.indexOf(e.target.value) === -1) {
            document.getElementById("allWorkOrder").checked = false;
            arrWorkOrderNumber.push(e.target.value);
            workOrderFilter[index]['is_change'] = true;
          }
        }
      } else {
        if (index === null) {
          arrWorkOrderNumber = [];
          workOrderFilter.forEach(element => {
            element['is_change'] = false
          });
        } else {
          const ind = arrWorkOrderNumber.indexOf(e.target.value);
          if (ind > -1) {
            arrWorkOrderNumber.splice(ind, 1);
            workOrderFilter[index]['is_change'] = false;
            document.getElementById("allWorkOrder").checked = false;
          }
        }
      }
    }
    
    this.setState({ work_order_number: arrWorkOrderNumber, allWorkOrderSelected: index === null ? !allWorkOrderSelected : false},() => {
      // console.warn('work_order_number', this.state.work_order_number);
    });    
  }

  clearWorkOrder = () => {
    const { workOrderFilter } = this.state;
    workOrderFilter.forEach(element => {
      element['is_change'] = false;
    });
    if (document.getElementById("allWorkOrder")) {
      document.getElementById("allWorkOrder").checked = false;
    }
    this.setState({ work_order_number: [], toggleWorkOrderFilter: false, allWorkOrderSelected: false }, () => {
      this.onFilterChange()
    });
  }

  closeWorkOrderFilter = () => {
    this.setState({ toggleWorkOrderFilter: false })
  }

  //#endregion

  //#region "Technician Filter"
  renderTechnicianFilters =  () => {
    const { toggleTechnicianFilter, fieldTechnicianFilter, technician__uuid } = this.state;
    return (
      <TechnicianOutsideAlerter
        closeTechnicianFilter={this.closeTechnicianFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtTechnician" placeholder={technician__uuid && technician__uuid.length === 0 ? 'All' : `${technician__uuid.length} items selected`} onChange={(e) => { this.onSearchTechnician(e) }} onFocus={() => {this.toggleTechnician() }} />
            {technician__uuid && technician__uuid.length === 0 && 
              <img src={chevronDown} alt="" onClick={() => { this.toggleTechnician() }} />
            }
            {technician__uuid && technician__uuid.length > 0 && 
              <img src={close} alt="" onClick={() => { this.clearTechnician() }} />
            }
          </div>
          {toggleTechnicianFilter && <div className="field-dropdown">
            <div className="field-dropdown-body">
              <div className="fitem-check">
                <input id="allTech" type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onTechnicianChanged(e, null)}} />
                <label htmlFor="allTech" className="fitem-ck-txt">All technicians</label>
              </div>
              {map(fieldTechnicianFilter, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item?.uuid} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onTechnicianChanged(e, index)}} checked={item.is_change} /> {/* checked={item.is_change} */}
                    <label htmlFor={item?.uuid} className="fitem-ck-txt">{item?.user?.first_name}, {item?.user?.last_name}</label>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearTechnician() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({toggleTechnicianFilter: false}) }}>Update</button>
            </div>
          </div>}
        </div>
      </TechnicianOutsideAlerter>
    )
  }

  toggleTechnician = () => {
    const { toggleTechnicianFilter } = this.state;
    if (toggleTechnicianFilter) {
      this.setState({ toggleTechnicianFilter: false })
    } else {
      this.setState({ toggleTechnicianFilter: true, toggleServiceOrderFilter: false,     toggleWorkOrderFilter: false, toggleStatusFilter: false })
    }
  }

  onSearchTechnician = (e) => {
    const { fieldTechnicianFilter } = this.state;
    if (e.target.value) {
      const data = fieldTechnicianFilter.filter( (obj) => {
        return (obj.user.last_name.toLowerCase()).indexOf(e.target.value.toLowerCase()) > -1
      });
      this.setState({fieldTechnicianFilter: data});
    } else {
      this.props.getFieldTechnicianFilter();
    }
  }

  onTechnicianChanged = (e, index) => {
    const { fieldTechnicianFilter, technician__uuid, allTechnicianSelected } = this.state;
    let arrTechnicianUuid = [...technician__uuid];
    if (e.target.checked) {
      if (index === null) {
        arrTechnicianUuid = [];
        fieldTechnicianFilter.forEach(element => {
          element['is_change'] = !allTechnicianSelected;
          if(!allTechnicianSelected) {
            arrTechnicianUuid.push(element?.uuid);
          }
        });
      } else {
        if (arrTechnicianUuid.indexOf(e.target.id) === -1) {
          document.getElementById("allTech").checked = false;
          arrTechnicianUuid.push(e.target.id)
          fieldTechnicianFilter[index]['is_change'] = true;
        }
      }
    } else {
      if (index === null) {
        arrTechnicianUuid = [];
        fieldTechnicianFilter.forEach(element => {
          element['is_change'] = false
        });
      } else {
        const ind = arrTechnicianUuid.indexOf(e.target.id);
        if (ind > -1) {
          arrTechnicianUuid.splice(ind, 1);
          fieldTechnicianFilter[index]['is_change'] = false;
          document.getElementById("allTech").checked = false;
        }
      }
    }
    this.setState({ technician__uuid: arrTechnicianUuid, allTechnicianSelected: index === null ? !allTechnicianSelected : false },() => {
      // console.warn('technician__uuid', this.state.technician__uuid);
    });    
  }

  clearTechnician = () => {
    const { fieldTechnicianFilter } = this.state;
    fieldTechnicianFilter.forEach(element => {
      element['is_change'] = false;
    });
    if (document.getElementById("allTech")) {
      document.getElementById("allTech").checked = false
    }
    this.setState({ technician__uuid: [], toggleTechnicianFilter: false }, () => {
      this.onFilterChange()
    });
  }

  closeTechnicianFilter = () => {
    this.setState({ toggleTechnicianFilter: false })
  }

  //#endregion 

  //#region "Status Filter"
  renderStatusFilters =  () => {
    const { toggleStatusFilter, status } = this.state;
    return (
      <StatusOutsideAlerter
        closeStatusFilter={this.closeStatusFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtStatus" placeholder={status && status.length === 0 ? 'All' : `${status.length} items selected`} onFocus={() => {this.toggleStatus() }} />
            {status && status.length === 0 && 
              <img src={chevronDown} alt="" onClick={() => { this.toggleStatus() }} />
            }
            {status && status.length > 0 && 
              <img src={close} alt="" onClick={() => { this.clearStatus() }} />
            }
          </div>
          {toggleStatusFilter && <div className="field-dropdown right">
            <div className="field-dropdown-body">
              {map(workOrderStatus.WorkOrderStatus, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item.value} type="checkbox" className="fitem-ck-input" onChange={ (e) => { this.onStatusChanged(e, index) } } checked={item.is_change} />
                    <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearStatus() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({toggleStatusFilter: false}) }}>Update</button>
            </div>
          </div>}
        </div>
      </StatusOutsideAlerter>
    )
  }

  toggleStatus = () => {
    const { toggleStatusFilter } = this.state;
    if (toggleStatusFilter) {
      this.setState({ toggleStatusFilter: false })
    } else {
      this.setState({ toggleStatusFilter: true, toggleServiceOrderFilter: false, toggleWorkOrderFilter: false, toggleTechnicianFilter: false })
    }
  }

  onStatusChanged = (e, index) => {
    const { status } = this.state;
    let arrStatus = [...status];
    if (e.target.checked) {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1) {
            arrStatus.push(element.value)
          }          
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          workOrderStatus.WorkOrderStatus[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }      
    } else {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          workOrderStatus.WorkOrderStatus[0]['is_change'] = false;
          workOrderStatus.WorkOrderStatus[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }      
    }
    this.setState({ status: arrStatus },() => {
      // console.warn('status', this.state.status);
    });    
  }

  clearStatus = () => {
    workOrderStatus.WorkOrderStatus.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ status: [], toggleStatusFilter: false }, () => {
      this.onFilterChange()
    });
  }

  closeStatusFilter = () => {
    this.setState({ toggleStatusFilter: false })
  }
  
  //#endregion

  countAppliedFilters = () => {
    const { scheduled_time__range, service_order__uuid, work_order_number, technician__uuid, status } = this.state;
    const queryParams = {
      scheduled_time__range: `${scheduled_time__range}`,
      service_order__uuid__in: service_order__uuid && service_order__uuid.length > 0 ? `${service_order__uuid.join()}` : null,
      work_order_number__in: work_order_number && work_order_number.length > 0 ? `${work_order_number}` : null,
      technician__uuid__in: technician__uuid && technician__uuid.length > 0 ? `${technician__uuid.join()}` : null,
      status__in: status && status.length > 0 ? `${status.join()}` : null,
    }
    const params = this.filterParams(queryParams);
    return Object.keys(params).length
  }

  clearAllFilters = () => {
    const { customerId } = this.props;
    this.setState({
      scheduled_time__range: null,
      service_order__uuid: [],
      work_order_number: [],
      technician__uuid: [],
      status: []
    }, () => {
      this.clearServiceOrder();
      this.clearWorkOrder();
      this.clearTechnician();
      this.clearStatus();
      this.props.getWorkOrderList({service_order__user__uuid:`${customerId}`, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
    });
  }

  renderNewService = () => {
    const { serviceOrder } = this.state;
    /**
     * AUTHOR: Ritesh Solanki
     * Changed: 24-11-2021 10:48 AM (Wednesday)
     * <DP-3374>View Services | Statuses show if no services assigned</DP-3374>
     * Find out status wise services using filter.
     */
    const { results } = serviceOrder;
    const actives = results?.filter(item => { return item?.is_active === true && item?.is_paused === false });
    const inactive = results?.filter(item => { return item?.is_active === false });
    const paused = results?.filter(item => { return item?.is_paused === true });
    const pending = this?.props?.customer?.status === 'pending';

    return (
      <React.Fragment>
        <div className="flex singleservice">
          <div className="card-col service-order-card">
            <div className="card">
              <div className="card-body">
                <div className="flex mb-20">
                  <h3 className="mb-0">Service Orders</h3>
                  {this?.props?.customer?.status !== "pending" && <a role="button" href="/#" className="flex ai-center justify-content-between" onClick={(e) => { e.preventDefault(); this.setState({isEditEnquiry: false}, () => {
                    this.props.toggleSidebar(false)
                    this.onChangeView(2)
                  })}}><img src={addGreenCircle} alt="" style={{marginRight: '6px'}}></img> Create Service Order</a>}
                </div>
                {/*
                  * AUTHOR: Ritesh Solanki
                  * Changed: 24-11-2021 10:48 AM (Wednesday)
                  * <DP-3374>View Services | Statuses show if no services assigned</DP-3374>
                  * @param actives - DP-3374 Changes
                */}
                {(this?.props?.customer?.status !== "pending" && actives && actives.length > 0) && <div className="service-status active-service">
                  <div className="active_service_list color-252730">
                    <div className="subs">
                      <strong className="color-22232A service-status-head">Active</strong>
                      {
                        map(actives, this.renderActiveService(actives.length))
                      }
                    </div>
                  </div>
                </div>}
                {/*
                  * AUTHOR: Ritesh Solanki
                  * Changed: 24-11-2021 10:48 AM (Wednesday)
                  * <DP-3374>View Services | Statuses show if no services assigned</DP-3374>
                  * @param paused - DP-3374 Changes
                */}
                {(this?.props?.customer?.status !== "pending" && paused && paused.length > 0) && <div className="service-status paused-service">
                  <div className="active_service_list lh-21 color-252730">
                    <div className="subs">
                      <strong className="color-22232A service-status-head">Paused</strong>
                      {
                        map(paused, this.renderPausedService(paused.length))
                      }
                    </div>
                  </div>
                </div>}
                {(this?.props?.customer?.status === "pending" && this?.state?.enquiryList && this?.state?.enquiryList?.results?.length) > 0 && <div className="service-status inactive-service">
                  <div className="active_service_list lh-21 color-252730">
                    <div className="subs">
                      <strong className="color-22232A service-status-head">Inquired</strong>
                      {
                        map(this?.state?.enquiryList?.results, this.renderInquiryService(this?.state?.enquiryList?.results?.length))
                      }
                    </div>
                  </div>
                </div>}
                {/*
                  * AUTHOR: Ritesh Solanki
                  * Changed: 24-11-2021 10:48 AM (Wednesday)
                  * <DP-3374>View Services | Statuses show if no services assigned</DP-3374>
                  * @param inactive - DP-3374 Changes
                */}
                {(this?.props?.customer?.status !== "pending" && inactive && inactive.length > 0) && <div className="service-status inactive-service">
                  <div className="active_service_list lh-21 color-252730">
                    <div className="subs">
                      <strong className="color-22232A service-status-head">Inactive</strong>
                      {
                        map(inactive, this.renderInactiveService(inactive.length))
                      }
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </div>
          <div className="w-100">
            <div className="work-orders-table">
              <div className="work-orders-toolbar">
                <div className="table-header sorting-btn-group flex ai-center">
                  <h3 className="mb-0">Work Orders</h3>
                  <div className="sorting flex ai-center no-bdr">
                    {
                      this?.props?.customer?.status !== "pending" && <>
                        <span className="mr-10">{this.countAppliedFilters()} filters applied</span>
                        <a role="button" href="/#" className="mr-10" onClick={(e) => { e.preventDefault(); this.clearAllFilters() }}>Clear all filters</a>
                      </>
                    }
                    <button className={this.state?.viewType === "upcoming" ? "btn btn-upcoming" : "btn btn-history"} onClick={ () => { this.upcomingWorkOrders() }}>Upcoming</button>
                    <button className={this.state?.viewType === "history" ? "btn btn-upcoming" : "btn btn-history"} onClick={ () => { this.historyWorkOrders() }}>History</button>
                    {/* <button className="btn btn-brand btn-bdr flex ai-center" onClick={() => {  this.setState({showAddons: true, currentRecord: {} }) }}><img src={addGreenCircle} alt=""></img>Create Work Order 1</button> */}
                  </div>
                </div>
                {this?.props?.customer?.status !== "pending" && <div className="sorting sorting-fields flex no-bdr">
                  <div className="fitem date-range-field mr-10">
                    <label>Date Range</label>
                    <RangePicker
                      format = 'MMM D, YYYY'
                      defaultValue={(!!this.state.startDate && !!this.state.endDate) ? [moment(this.state.startDate), moment(this.state.endDate)] : []}
                      onChange = {(e) => {this.onDateRangeChange(e)} }
                    />
                  </div>
                  <div className="fitem service-order-field mr-10">
                    <label>Service Order</label>
                    {this.renderServiceOrderFilters()}
                  </div>
                  <div className="fitem service-order-field mr-10">
                    <label>Work Order</label>
                    {this.renderWorkOrderFilters()}
                  </div>
                  <div className="fitem service-order-field mr-10">
                    <label>Technician</label>
                    {this.renderTechnicianFilters()}
                  </div>
              
                  <div className="fitem service-order-field">
                    <label>Status</label>
                    {this.renderStatusFilters()}
                  </div>
                </div>}
              </div>
              {this?.props?.customer?.status !== "pending" && this.renderWorkOrders()}
              {this?.props?.customer?.status === "pending" && <div style={{textAlign: "center", fontSize: "14px"}}>
                <span className="noWorkOrder"><ToolFilled /></span>
                <p className="mb-10" style={{fontWeight: "bold"}}>
                  {this.state?.viewType === "upcoming" ? "No Upcoming Work Orders" : "No History Work Orders"}
                </p>
                <p>Work orders will appear here when a service is active.</p>
              </div>}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderWorkOrders = () => {
    const { 
      workOrderList,
      workOrderListPagination,
      workOrderCount,
      viewType,
      isDeleteWOModalVisible,
      selectedService
    } = this.state;

    /*
    let isPausedApply = false;
    if (selectedService && Object.keys(selectedService).length > 0) {
      const current_date = moment().format("YYYY-MM-DD");
      const pause_from = selectedService?.pause_obj?.pause_from;
      const pause_to = selectedService?.pause_obj?.pause_to;
      if (current_date >= pause_from && (current_date <= pause_to || !pause_to) ) {
        isPausedApply = true;
      }
    }
    */
   
    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          className="tablebody service_history_table"
          //rowClassName={isPausedApply ? "disabled-row" : null }
          dataSource={workOrderList}
          pagination={{ ...workOrderListPagination, total: workOrderCount }}
          columns={viewType === 'upcoming' ? DataTable.UpComingWorkOrders(this) : DataTable.HistoryWorkOrders(this)}
          onChange={this.onWorkOrderHandleChange}
          position={false}
        />
        <Modal
          visible={isDeleteWOModalVisible}
          okText={"Delete"}
          cancelText={"Cancel"}
          onOk={() => {
            this.deleteWorkOrder()
            this.setState({isDeleteWOModalVisible: false})
          }}
          onCancel={() => {
            this.setState({isDeleteWOModalVisible: false})
          }}
          className="delete_user_modal"
          width={400}
        >   
          <h3>{`Delete ${viewType === 'upcoming' ? "Upcoming" : "Past"} Work Order`}</h3>
          <p>{`Are you sure you would like to delete this ${viewType === 'upcoming' ? 'upcoming' : 'past'} work order?`}</p>
          <p>Any changes made to this work order will be lost.</p>
        </Modal>
      </React.Fragment>
    )
  }

  // render all service
  renderAllService = () => {
    const { serviceOrder, enquiryList } = this.state;
    return (
      <React.Fragment>
        <div className="flist allservice pb-0">
          {
            map(serviceOrder?.results, this.renderService(false))
          }
          {this.renderAdditionalServiceBox()}
        </div>
        {/*In-active Service*/}
        <span className="hrline"><small>Enquired Service</small></span>
        <div className="flist allservice pb-0">
          {
            map(enquiryList?.results, this.renderService(true))
          }
        </div>
      </React.Fragment>
    )
  }

  //render Service Details
  renderServiceDetails = (item, index) => {
    let { selectedService, unavailableDays } = this.state;
    let misc_total = 0;

    map(item?.calculated_price?.misc_services, (item) => {
      misc_total = (misc_total + item?.price)
    });

    if (selectedService?.uuid === item?.uuid) {
      return (
        <React.Fragment key={`serviceDetail${index}`}>
          <div className="mt-10">
            <div className="">
              <h5>Service Details</h5>
              <div className="sdetail">
                <div className="subs">
                  <strong className="color-297C78 d-flex ai-center justify-content-start" onClick={() => { this.props.tabChange(3) }}><span>Dogs</span> <img className="ml-5" src={share} alt="" /></strong>
                  <span className="d-block">{item?.calculated_price?.pet_count ? item?.calculated_price?.pet_count : ''}</span>
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="flex ai-center">This location has a doogy door <CheckOutlined /></span>
                  <span className="flex ai-center">Technicians can clean with her dog outside <CheckOutlined /></span>
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Cleaning areas</span>
                  {
                    map(item?.calculated_price?.cleaning_areas && item?.calculated_price?.cleaning_areas?.items, (item, i) => {
                      return (
                        <div className="flex" key={`clean_area${i}`}>
                          <div className="flex-1" key={`cleaning_areas${i}`}>
                            {item.area && formattedAreas[item.area] ? formattedAreas[item.area] : 'Other' }
                          </div>
                          <div className=""><b>${item?.price || '0'}</b></div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Addons</span>
                  {
                    map(item?.calculated_price?.recurring_add_ons && item?.calculated_price?.recurring_add_ons?.recurring_addon_items, (item, i) => {
                      return (
                        <div className="flex" key={`clean_area${i}`}>
                          <div className="flex-1" key={`cleaning_areas${i}`}>
                            {item.name ? item.name : ''}
                          </div>
                          <div className=""><b>${item?.price || '0'}</b></div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Miscellaneous</span>
                  {item?.calculated_price?.misc_services && item?.calculated_price?.misc_services.length > 0 &&
                    <span className="">Item</span>
                  }                  
                  {
                    map(item?.calculated_price?.misc_services && item?.calculated_price?.misc_services, (item, i) => {
                      return (
                        <div className="flex" key={`clean_area${i}`}>
                          <div className="flex-1" key={`cleaning_areas${i}`}>
                            {item.item ? item?.item : ''}
                          </div>
                          <div className=""><b>${item?.price || '0'}</b></div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Cleaning notes</span>
                  <span className="service-type-body">{item?.cleaning_notes ? item?.cleaning_notes : 'None'}</span>
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Scooped waste disposal area</span>
                  <span className="service-type-body">{item?.disposal_location ? item?.disposal_location : 'None'}.</span>
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Preferred Service Days</span>
                  <div className="inline-check-list service-type-body">
                    { unavailableDays && unavailableDays.filter(item => !item.checked).length < 7  ? 
                      map(unavailableDays, (item, i) => {
                        if (!item?.checked) {
                          return(
                            <label className="fitem-ck-txt" key={i} htmlFor={`days${i}`}>{item?.value}, </label>  
                          )
                        }
                      })
                      :<label className="fitem-ck-txt"> Any </label> }
                  </div>
                </div>
              </div>
              <div className="sdetail">
                <div className="subs">
                  <span className="service-type-title">Preferred Technician</span>
                  {
                    item?.preferred_technician?.user?.first_name && 
                    <span className="service-type-body">{`${item?.preferred_technician?.user?.first_name} ${item?.preferred_technician?.user?.last_name}`}</span>
                  }
                  {
                    !item?.preferred_technician?.user?.first_name && 
                    <span className="service-type-body">None</span>
                  }
                </div>
                <div className="subs">
                  <span className="service-type-title">Average Clean Time <InfoCircleOutlined title="Average clean time is calculated over the last eight work orders." /></span>
                  <span className="service-type-body">{item?.average_clean_time}</span>
                </div>
              </div>
              <hr />
              {/* <button
                type="button"
                className="btn btn-brand btn-bdr btn-full"
                onClick={() => this.onUpdateDays()}
              >Update Service Days</button> */}
            </div>
            <div className="mt-10">
              <div className="">
                <div className="sdetail">
                  {/* {item && item?.frequency && <div className="subs">
                  <span className="flex ai-center">{`${FREQUENCY_MAPPING[item?.frequency]} services & ${item?.pet_count} ${item?.pet_count > 1 ? 'dogs' : 'dog'} `}</span>
                  </div>} */}
                
                  <div className="subs flex">
                    <span className="service-type-title">{`${FREQUENCY_MAPPING[item?.frequency]} services & ${item?.pet_count} ${item?.pet_count > 1 ? 'dogs' : 'dog'} `}</span>
                    <div className="flex" key={`service_base_price`}>
                      <div className="flex-1"></div>
                      <div className="">${item?.calculated_price?.service_base_price || 0}</div>
                    </div>
                  </div>

                  <div className="subs flex">
                    <span className="service-type-title">Cleaning Areas</span>
                    <div className="flex" key={`clean_area_total`}>
                      <div className="flex-1"></div>
                      <div className="">${item?.calculated_price?.cleaning_areas?.total_price || 0}</div>
                    </div>
                  </div>

                  <div className="subs flex">
                    <span className="service-type-title">Addons</span>
                    <div className="flex" key={`clean_area_total`}>
                      <div className="flex-1"></div>
                      <div className="">${item?.calculated_price?.recurring_add_ons?.total_recurring_addon_cost || 0}</div>
                    </div>
                  </div>

                  <div className="subs flex">
                    <span className="service-type-title">Miscellaneous</span>
                    <div className="flex" key={`clean_area_total`}>
                      <div className="flex-1"></div>
                      <div className="">${misc_total}</div>
                    </div>
                  </div>
                  <div className="subs">
                    <span className="flex ai-center">
                      <b>Servicer Order Total(excl. tax) </b>
                      <b className="mr-0">${`${item?.calculated_price?.total_price_per_service_incl_miscellaneous || 0}`}</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }
  }

  // render service history table
  serviceHistoryTable = () => {
    const { selectedHistory, historyPagination, historyCount } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          rowClassName={(record) => { if (record.status === 'cancelled') { return 'cancelled' } }}
          dataSource={selectedHistory}
          pagination={{ ...historyPagination, total: historyCount }}
          onChange={this.handleTableChange}
          columns={DataTable.Service(this)}
          onRow={(record) => ({
            onClick: () => {
              this.setState({ currentHistory: record }, () => {
                this.props.getServiceHistory({service__uuid: record?.uuid})
                this.toggleViewHistory(true)
              })
            },
          })}
          className="tablebody service_history_table"
        />
      </React.Fragment>)
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3089>Delete a Service Pause for a Residential Custome</DP-3089>
   */
  confirmDeletePause = (pause_uuid, pause_type) => {
    this.setState({
      isDeletePause: true,
      pause_uuid: pause_uuid,
      pause_type: pause_type
    })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3089>Delete a Service Pause for a Residential Custome</DP-3089>
   */
  deletePause = () => {
    const { pause_uuid, pause_type, pauseList, selectedService } = this.state;
    const {
      getServiceOrderById,
      deletePauseService,
      getPauseService,
      getWorkOrderList,
      customerId
    } = this.props;

    deletePauseService(pause_uuid);
    
    if (pause_type === 'upcoming') {
      let idx = pauseList?.upcoming?.findIndex(obj => obj?.uuid === pause_uuid);
      if (idx > -1) {
        pauseList.upcoming.splice(idx, 1);
        this.setState({ pauseList });
      }      
    } else {
      let idx = pauseList?.history?.findIndex(obj => obj?.uuid === pause_uuid);
      if (idx > -1) {
        pauseList.history.splice(idx, 1);
        this.setState({ pauseList });
      }
    }
    /**
     * AUTHOR: Ritesh Solanki
     * <DP-3686></DP-3686>
     * Call Service Order Detail api after sometimes as delete api takes some time to fire and get 
     * service order detail api calls so data not comes up correctly.
     */
    setTimeout(() => {
      getServiceOrderById(selectedService?.uuid);
      getPauseService({ service_order__uuid: selectedService?.uuid });
      getWorkOrderList({service_order__user__uuid:`${customerId}`, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
    }, 1000);    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3673>Sprint 6 | Single Service -> Future Pause | Details and title are not populated in edit pause</DP-3673>
   */
  editUpcomingPause = (item) => {
    let { selectedService } = this.state;
    selectedService = Object.assign(selectedService, { pause_obj: item});
    this.togglePauseService(true);
  }

  backToResidentialList = () =>{
    this.onClearStorage();
    this.props.history.push('/residential')
  }

  onClearStorage = () => {
    this.setState({selectedService:{}},()=>{
      sessionStorage.removeItem('step1');
      sessionStorage.removeItem('step2');
      sessionStorage.removeItem('calcData');
      sessionStorage.removeItem('pricingCalc');
      sessionStorage.removeItem('basicDetail');
    })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3685></DP-3685>
   */
  isServiceInProgress = (pause_from, pause_to) => {
    if (pause_from) {
      const current_date = moment().format("YYYY-MM-DD");
      if (current_date >= pause_from && (current_date <= pause_to || !pause_to) ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  //render selected service
  renderSelectedService = () => {
    const { selectedService, pauseList, is_upcoming, isDeletePause, viewType } = this.state;
    const { customerId } = this.props;
    const { is_paused, pause_obj } = selectedService;
    const { upcoming, history } = pauseList;
    const isPending = this?.props?.customer?.status === 'pending';

    return (
      <React.Fragment>
        <div className="filter_wrapper">
          <ul className="breadcrumb">
            <li><span onClick={() => {
              this.onClearStorage();
              this.onChangeView(0);
              if (customerId) {
                this.setState({
                  scheduled_time__range: null,
                  service_order__uuid: [],
                  work_order_number: [],
                  technician__uuid: [],
                  status: [],
                  isServiceDetail: false,
                }, () => {
                  workOrderStatus.WorkOrderStatus.forEach(element => {
                    element['is_change'] = false;
                  });
                  this.props.viewServiceDetail(false, {});
                  this.props.getFieldTechnicianFilter();
                  if (viewType === "upcoming") {
                    this.props.getWorkOrderFilter({service_order__user__uuid: customerId, service_order__uuid: selectedService?.uuid, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
                  } else if (viewType === "history") {
                    this.props.getWorkOrderFilter({service_order__user__uuid: customerId, service_order__uuid: selectedService?.uuid, scheduled_time__lt: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
                  }
                  this.props.getWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
                })
                this.props.getServiceOrder({ user__uuid: customerId }) // get service orders
              }}}>Services</span></li>
            <li><span>{!isEmpty(selectedService?.service_address) ? `${selectedService?.service_address?.address}, ${selectedService?.service_address?.city}, ${selectedService?.service_address?.state} ${selectedService?.service_address?.zip_code}` : '-'}</span></li>
          </ul>
        </div>
        <div className="flex singleservice">
          <div className="card-col service-order-card">
            <div className="card">
              <div className="card-body">
                {this.renderServiceOverview(selectedService)}
              </div>
            </div>
            {!isPending && <div className="card pause-card mt-20">
              <div className="card-head flex ai-center">
                <h5>Pauses</h5>
                <div className="sorting-btn-group flex ai-center">
                  <button type="button" className={is_upcoming === true ? "btn btn-upcoming" : "btn btn-history"} onClick={(e) => { this.setState({ is_upcoming: true }) }} >Upcoming</button>
                  <button type="button" className={is_upcoming === false ? "btn btn-upcoming" : "btn btn-history"} onClick={(e) => { this.setState({ is_upcoming: false }) }}>History</button>
                </div>
              </div>
              <div className="card-body">
                {is_upcoming && <React.Fragment>
                  {map(upcoming && upcoming.length > 0 && upcoming, (item, index) => {
                    return item?.service_order_uuid === selectedService.uuid ? (
                      <div className="pause-list-block flex ai-center" key={`pauseService${index}`}>
                        <div className="pause-heading">
                          <a href="javascript: void(0)">{item?.pause_from ? moment(item?.pause_from).format('MMM DD, YYYY') : ''} to {item?.pause_to ? moment(item?.pause_to).format('MMM DD, YYYY') : 'Indefinite'}</a>
                          <span>{item?.reason?.reason}</span>
                        </div>
                        <div className="flex ai-center">
                          {this.isServiceInProgress(item?.pause_from, item?.pause_to) && 
                            <button type="button" className="btn btn-inprogress">In Progress</button>
                          }
                          {!this.isServiceInProgress(item?.pause_from, item?.pause_to) && 
                            <button type="button" className="btn btn-upcoming">Upcoming</button>
                          }
                          {/* {item?.upcoming && <button type="button" className="btn btn-upcoming">Upcoming</button>}
                          {!item?.upcoming && <button type="button" className="btn btn-inprogress">In Progress</button>} */}
                          <div className="position-relative pause-dropdown">
                            <button className="dots-button"><span></span><span></span><span></span></button>
                            <ul className="pause-dropdownmenu">
                              <li><a href="#" onClick={(e) => { e.preventDefault(); this.editUpcomingPause(item) }}>Edit Pause</a></li>
                              <li><a href="#" onClick={(e) => { e.preventDefault(); this.confirmDeletePause(item?.uuid, 'upcoming')}}>Delete Pause</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>) : <span>No upcoming pause found</span>
                  })
                  }
                  {(!upcoming || upcoming.length === 0) && <span>No upcoming pause found</span>}
                </React.Fragment>}
                {!is_upcoming && <React.Fragment>
                  {map(history && history.length > 0 && history, (item, index) => {
                    return (
                      <div className="pause-list-block flex ai-center" key={`pauseService${index}`}>
                        <div className="pause-heading">
                          <a href="javascript: void(0)">{item?.pause_from ? moment(item?.pause_from).format('MMM DD, YYYY') : ''} to {item?.pause_to ? moment(item?.pause_to).format('MMM DD, YYYY') : 'Indefinite'}</a>
                          <span>{item?.reason?.reason}</span>
                        </div>
                        {/* <div className="flex ai-center">
                          <div className="position-relative pause-dropdown">
                            <button className="dots-button"><span></span><span></span><span></span></button>
                            <ul className="pause-dropdownmenu">
                              <li><a href="#" onClick={(e) => { e.preventDefault(); this.editUpcomingPause(item)}}>Edit Pause</a></li>
                              <li><a href="#" onClick={(e) => { e.preventDefault(); this.confirmDeletePause(item?.uuid, 'history') }}>Delete Pause</a></li>
                            </ul>
                          </div>
                        </div> */}
                      </div>)
                  })
                  }
                  {(!history || history.length === 0) && <span>No pause history found</span>}
                </React.Fragment>}
                <Modal
                  visible={isDeletePause}
                  okText={"Delete"}
                  cancelText={"Cancel"}
                  onOk={() => {
                    this.deletePause();
                    this.setState({isDeletePause:false});
                  }}
                  onCancel={() => {
                    this.setState({isDeletePause:false});
                  }}
                  className="delete_user_modal"
                  width={400}
                >   
                  <h3>Delete Pause?</h3>
                  <p>Are you sure you would like to delete this pause?</p>
                  <p>Once deleted, it will be removed from the pause panel</p>
                </Modal>
              </div>
            </div>}
          </div>

          <div className="work-orders-table">
            {!!is_paused && <div className="order-alert-warning">
              <div>
                <p>This service order is currently  paused and may affect upcoming work orders:</p>
                <div className="alert-dateblock">
                  <span>{moment(pause_obj?.pause_from).format("MMMM DD, YYYY")} to {pause_obj?.pause_to ? moment(pause_obj?.pause_to).format("MMMM DD, YYYY") : 'Indefinite'}</span>
                  { pause_obj?.reason?.reason }
                </div>
              </div>
              <div className="flex ai-center alert-cation-btn">
                <Popconfirm
                  title="Are you sure?"
                  onConfirm={() => {
                    this.props.updatePauseService(pause_obj?.uuid, {
                      is_end_pause: true
                    });
                    // this.props.deletePauseService(pause_obj?.uuid);
                    setTimeout(() => this.rerender(), 1000);
                  }}
                  okText="Yes"
                  cancelText="No"
                  overlayClassName={"popup-width"}
                >
                  <a role="button" href="/#"><img src={playIcon} alt=""/>End Pause</a>
                </Popconfirm>
                <a role="button" href="/#" onClick={(e) => {
                  e.preventDefault();
                  // this.props.getPauseService({ service_order__uuid: selectedService?.uuid }) // get pause service list
                  this.togglePauseService(true);
                }}><img src={editIcon} alt=""/>Edit Pause</a>
              </div>
            </div>}
            <div className="work-orders-toolbar">
              <div className="table-header sorting-btn-group flex ai-center">
                <h3 className="mb-0">Work Orders</h3>
                <div className="sorting flex ai-center no-bdr">
                  <button
                    className={this.state?.viewType === "upcoming" ? "btn btn-upcoming" : "btn btn-history"}
                    onClick={ () => { this.upcomingWorkOrders() }}
                  >
                    Upcoming
                  </button>
                  <button
                    className={this.state?.viewType === "history" ? "btn btn-upcoming" : "btn btn-history"}
                    onClick={ () => { this.historyWorkOrders() }}
                  >
                    History
                  </button>
                  {!isPending && <button className="btn btn-brand btn-bdr flex ai-center" onClick={() => {console.log("6");  this.setState({showAddons: true, currentRecord: selectedService, transection_type: 'Create' }) }}><img src={addGreenCircle} alt=""></img>Create Work Order</button>}
                </div>
              </div>
              {!isPending && <div className="sorting sorting-fields flex no-bdr">
                <div className="fitem date-range-field mr-10">
                  <label>Date Range</label>
                  <RangePicker
                    format = 'MMM D, YYYY'
                    defaultValue={(!!this.state.startDate && !!this.state.endDate) ? [moment(this.state.startDate), moment(this.state.endDate)] : []}
                    onChange = {(e) => {this.onDateRangeChange(e)} }
                  />
                </div>
                <div className="fitem service-order-field mr-10">
                  <label>Work Order</label>
                  {this.renderWorkOrderFilters()}
                </div>
                <div className="fitem service-order-field mr-10">
                  <label>Technician</label>
                  {this.renderTechnicianFilters()}
                </div>
                <div className="fitem service-order-field">
                  <label>Status</label>
                  {this.renderStatusFilters()}
                </div>
              </div>}
            </div>
            {!isPending && this.renderWorkOrders()}
            {isPending && <div style={{textAlign: "center", fontSize: "14px"}}>
              <span className="noWorkOrder"><ToolFilled /></span>
              <p className="mb-10" style={{fontWeight: "bold"}}>
                {this.state?.viewType === "upcoming" ? "No Upcoming Work Orders" : "No History Work Orders"}
              </p>
              <p> Work orders will appear here when a service is active.</p>
            </div>}
            {/* {this.serviceHistoryTable()} */}
          </div>
        </div>
      </React.Fragment>
    )
  }

  // render views
  renderViews = () => {
    const { selectedView, enquiryList, isEditEnquiry} = this.state;
    
    switch (selectedView) {
    case 0:
      return this.renderNewService(); //this.renderAllService(); 
    case 1:
      return this.renderSelectedService();
    case 2:
      return (
        <React.Fragment>
          <div className="filter_wrapper">
            <ul className="breadcrumb">
              <li><span onClick={() => {this.props.toggleSidebar(true); this.onChangeView(0);}}>{`Back`}</span></li>
            </ul>
          </div>
          <AddService
            customerId={this.props.customerId}
            onChangeView={this.onChangeView}
            service={enquiryList?.results?.[0]}
            field_office_uuid={enquiryList?.results?.[0]?.field_office_uuid || ''}
            isEditEnquiry={isEditEnquiry}
            // reducer
            zipcodeCheck={this.props.zipcodeCheck}
            PricingCalc={this.props.pricingCalc}
            serviceOrderEnquiry={this.props.serviceOrderEnquiry}
            customerList={this.props.customerList}
            AddCard={this.props.AddCard}
            serviceOrder={this.props.serviceOrder}
            CardList={this.props.CardList}
            Service={this.props.service}
            fieldTechnicianFilter={this.props.fieldTechnicianFilter}
            // api
            getServiceOrder={this.props.getServiceOrder}
            getFieldOfficeById={this.props.getFieldOfficeById}
            getFranchiseById={this.props.getFranchiseById}
            pricingCalculator={this.props.pricingCalculator}
            resetCheckZipcode={this.props.resetCheckZipcode}
            resetPricingCalculator={this.props.resetPricingCalculator}
            getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
            updateServiceOrderEnquiry={this.props.updateServiceOrderEnquiry}
            checkZipCode={this.props.checkZipCode}
            getCustomerDetail={this.props.getCustomerDetail}
            addNewCard={this.props.addNewCard}
            addServiceOrder={this.props.addServiceOrder}
            updateServiceOrder={this.props.updateServiceOrder}
            updatePartialServiceOrder={this.props.updatePartialServiceOrder}
            getCardList={this.props.getCardList}
            deleteCard={this.props.deleteCard}
            rerender={this.rerender}
          />
        </React.Fragment>)
    case 3:
      return (
        <React.Fragment>
          <div className="filter_wrapper">
            <ul className="breadcrumb">
              <li  onClick={() => this.backToResidentialList()}  className="fs-14"><span className="pointer"><i className="las la-angle-left"></i> Back to All Residential Customers</span></li>
            </ul>
          </div>
          <ReviewService
            {... {... this.props, ...this.state} }
            customerId={this.props.customerId}
            onChangeView={this.onChangeView}
            backToResidentialList={this.backToResidentialList}
            service={enquiryList?.results?.[0]}
            field_office_uuid={enquiryList?.results?.[0]?.field_office_uuid || ''}
            isEditEnquiry={isEditEnquiry}
            // reducer
            zipcodeCheck={this.props.zipcodeCheck}
            PricingCalc={this.props.pricingCalc}
            serviceOrderEnquiry={this.props.serviceOrderEnquiry}
            customerList={this.props.customerList}
            AddCard={this.props.AddCard}
            serviceOrder={this.props.serviceOrder}
            CardList={this.props.CardList}
            Service={this.props.service}
            fieldTechnicianFilter={this.props.fieldTechnicianFilter}
            // api
            getServiceOrder={this.props.getServiceOrder}
            getFieldOfficeById={this.props.getFieldOfficeById}
            getFranchiseById={this.props.getFranchiseById}
            pricingCalculator={this.props.pricingCalculator}
            resetCheckZipcode={this.props.resetCheckZipcode}
            resetPricingCalculator={this.props.resetPricingCalculator}
            getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
            updateServiceOrderEnquiry={this.props.updateServiceOrderEnquiry}
            checkZipCode={this.props.checkZipCode}
            getCustomerDetail={this.props.getCustomerDetail}
            addNewCard={this.props.addNewCard}
            addServiceOrder={this.props.addServiceOrder}
            updateServiceOrder={this.props.updateServiceOrder}
            updatePartialServiceOrder={this.props.updatePartialServiceOrder}
            getCardList={this.props.getCardList}
            deleteCard={this.props.deleteCard}
            deActivateCustomerConfirm={this.props.deActivateCustomerConfirm}
            updateCustomer={this.props.updateCustomer}
            cancelReviewService={this.cancelReviewService}
          />
        </React.Fragment>)
    default:
      return this.renderNewService()
    }
  }

  render() {
    const { 
      loader,
      pauseServiceVisible,
      selectedService,
      viewHistory,
      editService,
      currentHistory,
      addOns,
      showAddons,
      currentRecord,
      serviceOrder,
      transection_type
    } = this.state;
    const { customerId } = this.props;
    let is_reedirection = this.getRedirectToWorkOrder();
    
    if(showAddons) {
      return <EditWorkOrder 
        {
          ...{
            serviceOrder: !is_reedirection ? serviceOrder.results[0] : {},
            addOns,
            currentRecord,
            transection_type,
            goback: (e) => {
              this.setState({showAddons: false});
              if (customerId) {
                this.onFilterChange();
              }
              if (selectedService && Object.keys(selectedService).length > 0) {
                this.props.getServiceOrderById(selectedService?.uuid, this?.props?.customer?.status === "pending");
              }
            }
          }
        }
      />
    }

    return (
      <div className="block-row p-0">
        <div className="container">
          {loader && <Loader />}
          {this.renderViews()}
          {pauseServiceVisible && <PauseService
            serviceId={selectedService?.uuid}
            customerId={this.props.customerId}
            visible={pauseServiceVisible}
            closeDrawer={() => this.togglePauseService(false)}
            getServiceOrder={this.props.getServiceOrder}
            getPauseService={this.props.getPauseService}
            pauseService={this.props.pauseService}
            updatePauseService={this.props.updatePauseService}
            getPauseReason={this.props.getPauseReason}
            deletePauseService={this.props.deletePauseService}
            viewService={this.props.viewService}
            service={this.props.service}
            selectedService={selectedService}
          />}
          {currentHistory && <ViewServiceHistory
            visible={viewHistory}
            currentHistory={currentHistory}
            closeDrawer={() => this.toggleViewHistory(false)}
            getServiceHistory={this.props.getServiceHistory} // api
            service={this.props.service} // reducers
          />}
          {editService && <EditService
            visible={editService}
            service={selectedService}
            addOns={addOns}
            closeDrawer={() => this.toggleEditService(false)}
            customerId={this.props.customerId}
            onEditSuccess={() => this.setState({isUpdateService: true}) }
            //APIs
            getServiceOrder={this.props.getServiceOrder}
            editService={this.props.editService}
            getFranchiseById={this.props.getFranchiseById}
            pauseService={this.props.pauseService}
            updatePauseService={this.props.updatePauseService}
            updateServiceLineItem={this.props.updateServiceLineItem}
            viewService={this.props.viewService}
            pricingCalculator={this.props.pricingCalculator}
            getGeocodeAddress={this.props.getGeocodeAddress}
            resetGeocodeAddress={this.props.resetGeocodeAddress}
            getFieldTechnicianList={this.props.getFieldTechnicianList}

            //reducers
            Service={this.props.service}
            PricingCalc={this.props.pricingCalc}
            GoogleApi={this.props.GoogleApi}
            fieldTechnician={this.props.FieldTechnician}
          />}
        </div>
      </div>
    );
  }
}

export default Services;
